// based on http://stackoverflow.com/a/9039885/177710

var iOS = function iOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
};
export var getMobileOS = function getMobileOS() {
  if (typeof window === 'undefined') return null;
  if (/android/i.test(window.navigator.userAgent || window.navigator.vendor) && !('MSStream' in window)) {
    return 'android';
  }
  if (iOS() && !('MSStream' in window)) {
    return 'ios';
  }
  return null;
};